import { SVGProps } from "react";

const GIBolt = (props: SVGProps<SVGSVGElement>) => <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256" width="1em" height="1em" {...props}><circle cx={128} cy={128} r={128} /><circle stroke="#fff" strokeWidth={18} cx={128} cy={128} r={101} /><path fill="#fff" d="M101.265 58.881h53.377l-28.835 51.29 53.1 5.232-78.643 81.716 24.95-62.497-48.121-5.661z" /></svg>;

export { GIBolt };